import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Wrapper from "../ImageWrapper"

const ImageP = () => {
  return (
    <Wrapper>
      <StaticImage
        src="../../../images/Reserved_SS22_P_7_a.jpg"
        alt="Product"
      />
      <StaticImage
        src="../../../images/Reserved_SS22_P_7_b.jpg"
        alt="Product"
      />
    </Wrapper>
  )
}

export default ImageP
